import _ from 'lodash'

export default function getRoundChoices() {
  const K = 1000
  const M = 1000 * K
  return [
    /* eslint no-multi-spaces: "off" */
    { value: 0, label: '0' },
    { value: 25 * K, label: '25K' },
    { value: 50 * K, label: '50K' },
    { value: 100 * K, label: '100K' },
    { value: 150 * K, label: '150K' },
    { value: 250 * K, label: '250K' },
    { value: 500 * K, label: '500K' },
    { value: 1 * M, label: '1M' },
    { value: 3 * M, label: '3M' },
    { value: Infinity, label: '5M+' },
  ]
}

export const roundSizeChoices = getRoundChoices()
export const roundSizeChoicesByValue = _.keyBy(roundSizeChoices, 'value')
export const roundSizeChoicesByLabel = _.keyBy(roundSizeChoices, 'label')

export function formatRounds(choiceIndex) {
  if (!choiceIndex) return 0
  return roundSizeChoices[choiceIndex].label
}
